import {WEB_APP_BASE_URL} from 'config/app.config';

/** The portal's plans page, opened in the top window (the player may itself be framed). */
export const plansPageUrl = () => `${WEB_APP_BASE_URL}/settings?tab=subscription`;

export const openPlansPage = () => {
  if (typeof window === 'undefined') return;
  const destination = plansPageUrl();
  try {
    window.top.location.assign(destination);
  } catch (_) {
    window.location.assign(destination);
  }
};
